import * as React from 'react'
import {useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {api} from '../api/api'
import ModalStatus from '../components/statusModal'
import '../css/login.css'
import AppProps from '../util/appProps'
import {errorSwitcher, isEnter, UNKNOWN_SERVER_ERROR} from '../util/util'

const ForgotPassword = (props: AppProps) => {
    const {t} = useTranslation('forgotPassword')
    const forgotRef = useRef(null) as any

    const [email, setEmail] = useState('')
    const [eEmail, setEEmail] = useState([])
    const [eOther, setEOther] = useState([])

    const [showModal, setShowModal] = useState(false)
    const toggleShowModal = () => setShowModal(!showModal)

    const updateErrors = (email, other) => {
        setEEmail(email)
        setEOther(other)
    }

    const handleErrors = errors => {
        const parsed = errorSwitcher(errors)
        updateErrors(parsed.email, parsed.other)
    }

    const modalData = {
        title: 'Restore Successful',
        text: 'Please check your inbox for an e-mail with additional instructions to restore your password.'
    }

    const login = async () => {
        updateErrors([], [])
        forgotRef.current.classList.toggle('active')
        try {
            const response = await api.resetPass(email)
            if (response && response.redirectUrl) {
                if (response.redirectUrl == '/restored') {
                    setShowModal(true)
                } else {
                    props.history.push(response.redirectUrl)
                }
            }
        } catch (e) {
            forgotRef.current.classList.toggle('active')
            handleErrors(e ? e.errors : UNKNOWN_SERVER_ERROR)
        }
    }

    return (
        <div className="common-pages-container text-center login-page">
            <ModalStatus data={modalData} show={showModal} toggle={toggleShowModal}/>
            <img src="https://static.persona.ly/images/logo_persona.svg" />
            <p>{t('reset y')}</p>

            {eOther && eOther.map(err => <div className="error" key={err}>{err}</div>)}

            <div className="contact-input-container">
                <input className={'contact-input small-text' + (eEmail.length > 0 ? ' error-input' : '')} type="email" name="email" placeholder="&nbsp;"
                    onInput={e => setEmail(e.currentTarget.value)} onKeyPress={e => isEnter(e) && login()}
                />
                <span className="contact-input-label">{t('type y')}</span>
            </div>
            {eEmail && eEmail.map(err => <div className="error-small" key={err}>{err}</div>)}

            <button ref={forgotRef} className="button-blue large animated" onClick={login}>{t('reset p')}<img src="https://static.persona.ly/images/arrow.svg" /></button>
        </div>
    )
}

export default ForgotPassword


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/forgotPassword.tsx